import { createAction, props } from '@ngrx/store';
import { AppError } from '@mona/shared/utils';

/**
 * Action to handle unexpected server error
 */
export const handleUnexpectedServerError = createAction('ERROR:HANDLE_UNEXPECTED_SERVER_ERROR', props<AppError>());
